import { call, put, takeEvery } from "redux-saga/effects";
import requestWithSubTenantIfNeeded from "../requestWithSubTenantIfNeeded";
import { request as refreshRequest } from "../getStartedRefresh/getStartedRefreshActions";
import * as actions from "./getStartedActionActions";
import type { WizardActionPayload } from "types/unifiedWizard";

type ActionWithPayload = ReturnType<typeof actions.request>;

function* getStartedAction(action: ActionWithPayload) {
  const { payload, resolve, reject } = action;
  try {
    yield call(requestWithSubTenantIfNeeded, "put", "onboarding-v2/get-started", {
      json: payload,
    });
    yield put(actions.requestSuccess());
    yield put(refreshRequest());
    if (resolve) yield call(resolve);
  } catch (error) {
    yield put(actions.requestFailure(error));
    if (reject) yield call(reject, error);
  }
}

function* saga() {
  yield takeEvery(actions.GET_STARTED_ACTION_REQUEST, getStartedAction);
}

export default saga;
